import { ColumnRank, ColumnBib, ColumnName, ColumnNoc, ColumnResult, ColumnQualification } from "components/common/TableColumns"
import Label from "components/general/Label"
import SportCode from 'components/common/SportCode'

export function ColumnRun({
    disableSort = true,
    className = 'text-end w-10',
    headerClassName = 'text-end w-10',
    label = '',
    remove = false,
    runNumber = ''
}) {

    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => { return props.sortOrder },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: `Run${runNumber}`,
            remove: remove,

            Cell: (props) => {
                let runRank = props.cell.row.original?.extendedResults?.find(er => er?.er_pos === runNumber)?.er_rank
                let runValue = props.cell.row.original?.extendedResults?.find(er => er?.er_pos === runNumber)?.er_value

                let irm = props.cell.row.original?.extendedResults?.find(er => er?.er_pos === runNumber)?.er_irm

                return (
                    irm
                    ? <SportCode discipline='BMX' entity='@IRM' code={irm} abbr={true} />
                    : props.cell.row.original.resultType === 'POINTS' && runValue && runRank
                        ? `${runValue} (${runRank})` 
                        : ''
                )
            },
        }
    )
}

export function ColumnRunSM({
    disableSort = true,
    className = 'text-end w-10',
    headerClassName = 'text-end w-10',
    label = '',
    remove = false,
    runNumber = ''
}) {

    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => { return props.sortOrder },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: `Run${runNumber}SM`,
            remove: remove,

            Cell: (props) => {
                let runValue = props.cell.row.original?.extendedResults?.find(er => er?.er_pos === runNumber)?.er_value2

                return (
                    props.cell.row.original.resultType === 'POINTS' 
                        ? `${runValue}` 
                        : ''
                )
            },
        }
    )
}

export function TableColumnsSummary() {
    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnBib({ label:"HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnRun({ label:"HeaderRun1", runNumber:'RUN1'}),
            ColumnRun({ label:"HeaderRun2", runNumber:'RUN2'}),
            ColumnRun({ label:"HeaderRun3", runNumber:'RUN3'}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnQualification({ className:"text-end fw-bold" }),
        ]
    )
}

export function TableColumnsSummarySM() {
    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnBib({ label:"HeaderNumber" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnRunSM({ label:"HeaderR1", runNumber:'RUN1'}),
            ColumnRunSM({ label:"HeaderR2", runNumber:'RUN2'}),
            ColumnRunSM({ label:"HeaderR3", runNumber:'RUN3'}),
            ColumnResult({ label: "HeaderTotal" }),
            ColumnQualification({ className:"text-end fw-bold" }),
        ]
    )
}